<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let isOpen = false;
	export let title = 'ขอบคุณที่ติดต่อเรา';
	export let message = 'เราจะติดต่อกลับในเวลาทำการ จ-ศ 8:00-17:00 น.';
	export let showCloseButton = true;
	export let autoClose = 0; // 0 = no auto close, >0 = auto close after X seconds

	let timeoutId: ReturnType<typeof setTimeout>;

	$: if (isOpen && autoClose > 0) {
		timeoutId = setTimeout(() => {
			closePopup();
		}, autoClose * 1000);
	}

	function closePopup() {
		isOpen = false;
		dispatch('close');
		if (timeoutId) clearTimeout(timeoutId);
	}

	function handleBackdropClick(event: MouseEvent) {
		if (event.target === event.currentTarget) {
			closePopup();
		}
	}

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			closePopup();
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />

{#if isOpen}
	<div
		role="dialog"
		aria-modal="true"
		tabindex="-1"
		class="popup-overlay"
		on:click={handleBackdropClick}
		on:keydown={handleKeydown}
	>
		<div class="popup-content">
			{#if showCloseButton}
				<button class="close-btn" on:click={closePopup} aria-label="Close popup">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
					>
						<line x1="18" y1="6" x2="6" y2="18"></line>
						<line x1="6" y1="6" x2="18" y2="18"></line>
					</svg>
				</button>
			{/if}

			<div class="popup-icon">
				<svg
					width="60"
					height="60"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
				>
					<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
					<polyline points="22,4 12,14.01 9,11.01"></polyline>
				</svg>
			</div>

			<h2 class="popup-title">{title}</h2>
			<p class="popup-message">{message}</p>

			<div class="popup-actions">
				<button class="btn-primary" on:click={closePopup}> ตกลง </button>
			</div>
		</div>
	</div>
{/if}

<style>
	.popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10000;
		padding: 1rem;
		animation: fadeIn 0.3s ease-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.popup-content {
		background: #ffffff;
		border-radius: 1rem;
		padding: 2rem;
		max-width: 28rem;
		width: 100%;
		position: relative;
		text-align: center;
		animation: slideIn 0.3s ease-out;
		box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
	}

	@keyframes slideIn {
		from {
			transform: translateY(-50px);
			opacity: 0;
		}
		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.close-btn {
		position: absolute;
		top: 1rem;
		right: 1rem;
		background: none;
		border: none;
		color: #666;
		cursor: pointer;
		padding: 0.5rem;
		border-radius: 0.5rem;
		transition: all 0.3s ease;
	}

	.close-btn:hover {
		background: #f0f0f0;
		color: #333;
	}

	.popup-icon {
		margin-bottom: 1rem;
		color: #10b981;
	}

	.popup-title {
		font-size: 1.5rem;
		font-weight: 600;
		color: #1f2937;
		margin: 0 0 1rem 0;
	}

	.popup-message {
		font-size: 1rem;
		color: #6b7280;
		line-height: 1.6;
		margin: 0 0 2rem 0;
	}

	.popup-actions {
		display: flex;
		justify-content: center;
		gap: 1rem;
	}

	.btn-primary {
		background: #10b981;
		color: white;
		border: none;
		padding: 0.75rem 2rem;
		border-radius: 0.5rem;
		font-size: 1rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		min-width: 100px;
	}

	.btn-primary:hover {
		background: #059669;
		transform: translateY(-1px);
	}

	.btn-primary:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		.popup-content {
			padding: 1.5rem;
			margin: 1rem;
		}

		.popup-title {
			font-size: 1.25rem;
		}

		.popup-message {
			font-size: 0.9rem;
		}
	}
</style>
